import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';
import { CSS_TRANSITION_DELAY } from '../const';

export const useStyles = makeStyles<Theme>(
    theme => ({
        root: {
            display: 'flex',
            backgroundColor: theme.palette.greys[100],
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: '10px 36px 0',
            animation: `$appear ${CSS_TRANSITION_DELAY}ms ease-in-out`,
        },
        '@keyframes appear': {
            '0%': {
                opacity: 0,
            },
            '100%': {
                opacity: 1,
            },
        },
    }),
    { classNamePrefix: 'drawer-my-profile' }
);
